export const BASE_URL = 'https://metadefender.opswat.com/';
export const BASE_FQDN_URL = 'https://metadefender.opswat.com/';

export const API = {
    backend: {
        baseUrl: 'api',
        defaultTimeout: 100000
    },
};
